import { CreateTenantBranch, TenantBranch } from "../../Models/TenantBranch";
import api from "../axios";

export const tenantBranchService = {
  getAll: async (): Promise<TenantBranch[]> => {
    const response = await api.get('/tenant-branch');
    return response.data;
  },

  create: async (data: CreateTenantBranch): Promise<string> => {
    const response = await api.post('/tenant-branch', data);
    return response.data;
  },

  update: async (id: string, data: TenantBranch): Promise<boolean> => {
    const response = await api.put(`/tenant-branch/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<boolean> => {
    const response = await api.delete(`/tenant-branch/${id}`);
    return response.data;
  },
};
